import {
  CardThemeModel,
  CardThemesV2Model,
  ICardThemesResponse,
  ICardThemesV2Response,
} from './entities';

export const getCardThemesMapper = (
  response: ICardThemesResponse,
): CardThemeModel => {
  return {
    themes: response.themes,
  };
};

export const getCardThemesV2Mapper = (
  response: ICardThemesV2Response[],
): CardThemesV2Model[] => {
  return response.map(response => {
    return {
      category: response.category,
      themes: response.themes,
    };
  });
};
